import { memo } from "react";
import { Pressable } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import { View, Text } from "@src/components";

interface ScenarioCardProps {
  scenarioName: string;
  cameraDisplayName: string;
  cameraSubtitle: string;
  isSelected?: boolean;
  onPress?: () => void;
}

const CARD_HEIGHT = 96;

export const ScenarioCard = memo(
  ({ scenarioName, cameraDisplayName, cameraSubtitle, isSelected, onPress }: ScenarioCardProps) => {
    const content = (
      <View style={[styles.cardBorder, isSelected && styles.cardBorderSelected]}>
        <View style={styles.cardContent}>
          <Text textStyle="sm/semibold" color="text" numberOfLines={2}>
            {scenarioName}
          </Text>
          <Text textStyle="xs/regular" color="textMuted" numberOfLines={1}>
            {cameraDisplayName}
          </Text>
          <Text textStyle="xxs/regular" color="textMuted" numberOfLines={1}>
            {cameraSubtitle}
          </Text>
        </View>
      </View>
    );

    if (!onPress) return content;

    return (
      <Pressable
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel={`Open ${scenarioName} details`}
        accessibilityState={{ selected: !!isSelected }}
      >
        {content}
      </Pressable>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  cardBorder: {
    borderRadius: theme.spacing.md,
    borderWidth: 1,
    overflow: "hidden",
    borderColor: theme.colors.borderCard,
    backgroundColor: theme.colors.surfaceCard,
  },
  cardBorderSelected: {
    borderColor: theme.colors.icon,
  },
  cardContent: {
    height: CARD_HEIGHT,
    padding: theme.spacing.xl,
    gap: theme.spacing.xs,
    justifyContent: "center",
  },
}));
